import z from 'zod';
import { createIdSchema } from '../../lib/util/id.js';
import { createStrictSchema } from '../../lib/util/zod-helpers.js';
import { LocaleInfoIdSchema } from '../locale/locale.types.js';
import { UserInfoIdSchema } from '../user/user.types.js';
import { movementTypes } from './movement.constants.js';
// ===== ID SCHEMAS =====
const MovementIdSchema = createIdSchema('movement');
const MovementTableSelectSchema = createStrictSchema()({
    id: MovementIdSchema,
    userId: UserInfoIdSchema.nullable(),
    canonicalName: z.string().nullable(),
    type: z.enum(movementTypes).nullable(),
    system: z.boolean(),
    name: z.string().nullable(),
    description: z.string().nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
const MovementTranslationTableSelectSchema = createStrictSchema()({
    movementId: MovementIdSchema,
    localeId: LocaleInfoIdSchema,
    nameTranslation: z.string(),
    descriptionTranslation: z.string().nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
// ===== POPULATED SCHEMAS =====
const PopulatedMovementTableSelectSchema = MovementTableSelectSchema.omit({
    createdAt: true,
    deletedAt: true,
}).extend({
    name: z.string(),
    description: z.string().nullable(),
});
// ===== PUBLIC SCHEMAS (to be used by outer layers) =====
const MovementInfoSchema = PopulatedMovementTableSelectSchema.extend({
    updatedAt: z.string(),
});
const MovementInfoIdSchema = MovementIdSchema;
export { MovementInfoIdSchema, MovementInfoSchema, MovementTableSelectSchema, MovementTranslationTableSelectSchema, PopulatedMovementTableSelectSchema, };
//# sourceMappingURL=movement.types.js.map